'use client';

import * as SubframeCore from '@subframe/core';
import React from 'react';
import * as SubframeUtils from '../utils';

interface AgentCardProps extends React.HTMLAttributes<HTMLDivElement> {
  icon?: React.ReactNode;
  title: string;
  description: string;
  className?: string;
}

export const AgentCard = React.forwardRef<HTMLDivElement, AgentCardProps>(function AgentCard(
  { icon, title, description, className, ...otherProps },
  ref,
) {
  return (
    <div
      ref={ref}
      className={SubframeUtils.twClassNames(
        'flex flex-col items-start gap-4 rounded-[16px] border border-solid border-white/5 bg-white/5 p-6 backdrop-blur-sm transition-all',
        className,
      )}
      {...otherProps}
    >
      <div className="bg-information-500/20 text-information-300 flex h-11 w-11 items-center justify-center rounded-full">
        <SubframeCore.IconWrapper>{icon}</SubframeCore.IconWrapper>
      </div>
      <div className="flex flex-col items-start gap-1">
        <span className="text-body-bold font-body-bold text-white">{title}</span>
        <span className="text-caption leading-tight text-white/60">{description}</span>
      </div>
    </div>
  );
});
